import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight, Star, Shield, Clock, Users, DollarSign } from 'lucide-react';
import Image from '../Assets/_car-big-side.png'
import { useNavigate } from 'react-router-dom';

const DriverSection = () => {
  const benefits = [
    { icon: DollarSign, text: "Quick Payments" },
    { icon: Clock, text: "Flexible Timings" },
    { icon: Shield, text: "Low Commissions" },
    { icon: Users, text: "Friendly Management" },
    { icon: Star, text: "Stable Orders" },
    { icon: CheckCircle, text: "24/7 Support" }
  ];

    const navigate = useNavigate();
 const handleClick = () => {
    navigate('/vehicles');
  };


  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-100 via-gray-100 to-gray-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          
          {/* Left Content */}
          <motion.div
            className="text-white"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {/* Header */}
            <motion.div variants={itemVariants}>
              <span className="inline-block bg-yellow-500 text-gray-900 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-6">
                FOR DRIVERS
              </span>
              <h2 className="text-gray-900 text-4xl md:text-5xl font-bold mb-6 leading-tight">
                DO YOU WANT TO<br />
                <span className="text-yellow-400">EARN WITH US?</span>
              </h2>
            </motion.div>

            {/* Description */}
            <motion.p 
              variants={itemVariants}
              className="text-xl text-gray-700 mb-8 leading-relaxed"
            >
              Are you an experienced driver willing to enrol with Maya Call Taxi? 
              Come join us for these great benefits!
            </motion.p>

            {/* Benefits List */}
            <motion.div 
              className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10"
              variants={containerVariants}
            >
              {benefits.map((benefit, index) => {
                const IconComponent = benefit.icon;
                return (
                  <motion.div
                    key={benefit.text}
                    variants={itemVariants}
                    className="flex items-center gap-4 p-4 bg-white/5 rounded-xl border border-white/10 hover:bg-white/10 transition-all duration-300 group"
                    whileHover={{ scale: 1.02, x: 5 }}
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-yellow-500 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <IconComponent className="w-6 h-6 text-gray-900" />
                    </div>
                    <span className="text-lg font-semibold text-gray-600">{benefit.text}</span>
                  </motion.div>
                );
              })}
            </motion.div>

            {/* CTA Button */}
            <motion.div variants={itemVariants}>
              <motion.button
      onClick={handleClick}
      whileHover={{ scale: 1.05, y: -2 }}
      whileTap={{ scale: 0.98 }}
      className="group bg-yellow-500 text-gray-900 px-8 py-4 rounded-xl font-bold text-lg shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center gap-3"
    >
      <span>JOIN US</span>
      <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
    </motion.button>
            </motion.div>

            {/* Trust Indicators */}
            <motion.div 
              className="flex flex-wrap items-center gap-6 mt-8 pt-8 border-t border-white/20"
              variants={itemVariants}
            >
              <div className="flex items-center gap-2">
                <div className="flex gap-1">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star key={star} className="w-4 h-4 fill-yellow-600 text-yellow-400" />
                  ))}
                </div>
                <span className="text-sm text-gray-600">4.9/5 Rating</span>
              </div>
              <div className="flex items-center gap-2">
                <Users className="w-5 h-5 text-yellow-400" />
                <span className="text-sm text-gray-600">500+ Drivers</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-yellow-400" />
                <span className="text-sm text-gray-600">Verified Partner</span>
              </div>
            </motion.div>
          </motion.div>

          {/* Right Content - Image */}
         {/* Right Content - Image */}
<motion.div
  className="relative"
  initial={{ opacity: 0, x: 50 }}
  whileInView={{ opacity: 1, x: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.8, delay: 0.2 }}
>
  <div className="relative rounded-2xl overflow-hidden shadow-2xl">
    {/* Replace this with your actual image */}
    <img 
      src={Image}
      alt="Maya Call Taxi Drivers"
      className="w-full h-auto object-cover aspect-[4/5]"
    />
    
    {/* Floating Elements */}
    {/* <motion.div
      className="absolute -top-4 -right-4 bg-yellow-500 text-gray-900 px-4 py-2 rounded-xl font-bold shadow-lg"
      animate={{ y: [0, -5, 0] }}
      transition={{ duration: 2, repeat: Infinity }}
    >
      +50% Earnings
    </motion.div>
    
    <motion.div
      className="absolute -bottom-4 -left-4 bg-white text-gray-900 px-4 py-2 rounded-xl font-bold shadow-lg"
      animate={{ y: [0, 5, 0] }}
      transition={{ duration: 2, repeat: Infinity, delay: 1 }}
    >
      ⭐ 4.9 Rating
    </motion.div> */}
  </div>
</motion.div>
        </div>
      </div>
    </section>
  );
};

export default DriverSection;